import { Home } from "lucide-react";
import { cn } from "@/lib/utils";

export const PropertyImage = ({ src, className = "", testid }) =>
  src ? (
    <img src={src} alt="" loading="lazy" className={cn("h-full w-full object-cover", className)} data-testid={testid} />
  ) : (
    <div className={cn("grid h-full w-full place-items-center bg-muted text-muted-foreground/60", className)} data-testid={testid}>
      <Home className="size-[28%] max-h-8 max-w-8" strokeWidth={1.5} />
    </div>
  );
